import type { SuretyAccountId } from "@inrev/common";
import {
	useAdminFetchAccount,
	useAdminFetchAccountCompanies,
	useAdminFetchAccountMetadata,
} from "@portal/api/account/admin";
import { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AdminBondRequestContext } from "./AdminBondRequestContext";
import type { AdminBondRequestFormData } from "./schema";

export const SelectedAdminAccountLoader = ({ accountId }: { accountId: SuretyAccountId }) => {
	const { setSelectedAccount } = useContext(AdminBondRequestContext);
	const { setValue } = useFormContext<AdminBondRequestFormData>();
	const { account } = useAdminFetchAccount(accountId);
	const { companies } = useAdminFetchAccountCompanies(accountId);
	const { metadata } = useAdminFetchAccountMetadata(accountId);

	useEffect(() => {
		if (!account || !companies || !metadata) return;
		setSelectedAccount({ ...account, companies, metadata });
		setValue("agencyId", account.agencyId);
		setValue("underwriterId", account.underwriterUserId);
		setValue("suretyAccountId", account.id);
	}, [account, companies, metadata, setSelectedAccount, setValue]);

	return null;
};
